import "/home/runner/work/pocket-dimension-dice/pocket-dimension-dice/components/SettingsModal/styles.module_built.css";
const classes = {"sliderWrapper":"-3NNHG_sliderWrapper","radio":"-3NNHG_radio","modalSection":"-3NNHG_modalSection","li":"-3NNHG_li","modal":"-3NNHG_modal","modalHeading":"-3NNHG_modalHeading","ul":"-3NNHG_ul","slider":"-3NNHG_slider","modalH2":"-3NNHG_modalH2","optionText":"-3NNHG_optionText","radioLabel":"-3NNHG_radioLabel","optionDescription":"-3NNHG_optionDescription","p":"-3NNHG_p","volume":"-3NNHG_volume","horizontalUl":"-3NNHG_horizontalUl","modalHeader":"-3NNHG_modalHeader"}
export default classes

const _sliderWrapper0 = classes["sliderWrapper"]
export { _sliderWrapper0 as "sliderWrapper" }

const _radio0 = classes["radio"]
export { _radio0 as "radio" }

const _modalSection0 = classes["modalSection"]
export { _modalSection0 as "modalSection" }

const _li0 = classes["li"]
export { _li0 as "li" }

const _modal0 = classes["modal"]
export { _modal0 as "modal" }

const _modalHeading0 = classes["modalHeading"]
export { _modalHeading0 as "modalHeading" }

const _ul0 = classes["ul"]
export { _ul0 as "ul" }

const _slider0 = classes["slider"]
export { _slider0 as "slider" }

const _modalH20 = classes["modalH2"]
export { _modalH20 as "modalH2" }

const _optionText0 = classes["optionText"]
export { _optionText0 as "optionText" }

const _radioLabel0 = classes["radioLabel"]
export { _radioLabel0 as "radioLabel" }

const _optionDescription0 = classes["optionDescription"]
export { _optionDescription0 as "optionDescription" }

const _p0 = classes["p"]
export { _p0 as "p" }

const _volume0 = classes["volume"]
export { _volume0 as "volume" }

const _horizontalUl0 = classes["horizontalUl"]
export { _horizontalUl0 as "horizontalUl" }

const _modalHeader0 = classes["modalHeader"]
export { _modalHeader0 as "modalHeader" }
